import { Text, Heading } from "../../../../components/common/typography";
import type { LoyaltyConfigDto } from "../../../../api";
import { IconCalendar, IconClock, IconCoin, IconStar } from "@tabler/icons-react";

interface LoyaltyConfigPreviewProps {
  config: LoyaltyConfigDto;
}

export function LoyaltyConfigPreview({ config }: LoyaltyConfigPreviewProps) {
  return (
    <div className="rounded-xl border border-borderDefault bg-bgWhite px-6 py-5 flex flex-col gap-4 max-sm:px-4">
      <Heading variant="h3" tone="dark" className="pb-4 border-b border-borderDefault">
        Current Configuration
      </Heading>

      <div className="grid grid-cols-2 gap-6 max-sm:grid-cols-1 max-sm:gap-4">
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 rounded-2xl bg-bgLight flex items-center justify-center flex-shrink-0">
            <IconStar size={26} className="text-textDark" />
          </div>
          <div className="flex flex-col gap-0.5">
            <Text variant="bodySm" tone="muted">Points Per 100 QAR</Text>
            <Heading variant="h3" tone="dark">
              {config.pointsPer100} point{config.pointsPer100 !== 1 ? "s" : ""}
            </Heading>
          </div>
        </div>

        <div className="flex items-center gap-4">
          <div className="w-14 h-14 rounded-2xl bg-bgLight flex items-center justify-center flex-shrink-0">
            <IconCoin size={26} className="text-textDark" />
          </div>
          <div className="flex flex-col gap-0.5">
            <Text variant="bodySm" tone="muted">QAR Per 100 Points</Text>
            <Heading variant="h3" tone="dark">
              QAR {(config.redemptionValuePer100Points ?? 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </Heading>
          </div>
        </div>

        <div className="flex items-center gap-4">
          <div className="w-14 h-14 rounded-2xl bg-bgLight flex items-center justify-center flex-shrink-0">
            <IconClock size={26} className="text-textDark" />
          </div>
          <div className="flex flex-col gap-0.5">
            <Text variant="bodySm" tone="muted">Validity Period</Text>
            <Heading variant="h3" tone="dark">{config.validityDays} days</Heading>
          </div>
        </div>
      </div>

      {config.updatedAt && (
        <div className="mt-auto flex items-center gap-2 border-t border-borderDefault pt-4">
          <IconCalendar size={15} className="text-textMuted flex-shrink-0" />
          <Text variant="bodySm" tone="muted">
            Last updated:{" "}
            {new Date(config.updatedAt).toLocaleString("en-GB", {
              day: "numeric",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </Text>
        </div>
      )}
    </div>
  );
}
